module.exports = __webpack_public_path__ + "static/media/chevron-up.81bc4e1f.svg";